import { Branding } from '@/types/Branding';
import { HttpService, createHttpService } from './HttpService';

export interface User {
  selfTenantUuid: string;
  language: string;
  branding: Branding;
}

export type MeResponse = {
  id: string;
  tenant_id: string;
  language: string;
};

type BrandResponse = {
  brand: number;
};

export class UserService {
  constructor(private httpService: HttpService) {
  }

  public async getUser(): Promise<User | null> {
    try {
      const me: MeResponse = await this.httpService.get<void, MeResponse>('/api/2/users/me');
      const brand: BrandResponse = await this.httpService.get<void, BrandResponse>('/api/1/profile');
      const branding: Branding = await this.httpService.get<void, Branding>(`/api/1/brands/${brand.brand}`);
      return {
        selfTenantUuid: me.tenant_id,
        language: me.language,
        branding
      };
    } catch (error) {
      return null;
    }
  }
}

export function createUserService(): UserService {
  const httpService: HttpService = createHttpService();

  return new UserService(httpService);
}
